<div class="ic-loading" *ngIf="loading">
  <ng-lottie width="400px" height="500px" containerClass="moving-box" [styles]="styles" [options]="options">
  </ng-lottie>
</div>
